import script from "./EditATalk.vue?vue&type=script&setup=true&lang=js"
export * from "./EditATalk.vue?vue&type=script&setup=true&lang=js"

import "./EditATalk.vue?vue&type=style&index=0&id=b8da6f1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8da6f1c"]])

export default __exports__